import { selectSelectedExternalBookingAPIKey } from '@store/ExternalBookingAPIKeyReducer'
import { useAppSelector } from '@store/hooks'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule } from '@utils/rules'
import { Form, Input, Switch } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedExternalBookingAPIKey())

  useEffect(() => {
    if (!item) return
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item label="Name" name="name" rules={[requiredRule()]}>
        <Input />
      </Form.Item>

      <Form.Item
        label="Is active"
        name="isActive"
        valuePropName="checked"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </Form>
  )
}

export default Update
